<template>
  <b-container v-if="!initialized" class="loader-section">
    <front-office-loader/>
  </b-container>
  <div v-else class="bg-light h-100">
      <div class="bg-company-img">
          <div class="container-fluid h-100">
              <div class="container pad-lg">
                  <headBar/>
              </div>
              <div v-if="success" class="container main-centered">
                <b-alert variant="success" show >
                  {{ $t('formation.offline.success') }}
                </b-alert>
              </div>
              <div v-else class="container main-centered">
                  <stepper :steps="steps" :classContent="classContent" ref="stepper" @submit="submitForm"  />
              </div>
          </div>

      </div>
  </div>

</template>

<script>
import stepper from '@/components/formation/offline/stepper'
import headBar from '@/components/formation/offline/header'
import frontOfficeLoader from '@/components/frontoffice/loader'

import CommonApi from '@/api/commonApi'

import { formatDateForOnlineRequest } from '@/utils/date'

export default {
  components: {
    stepper,
    headBar,
    frontOfficeLoader
  },

  data () {
    return {
      commonApi: new CommonApi(),
      classContent: {
        'pad-2': true
      },
      steps: [],
      initialized: false,
      success: null
    }
  },
  methods: {
    formatDatesBeforeSubmit (data) {
      // foreach récursif sur toute la data, jusqu'à trouver des objets "Date" pour les transformer
      for (const [key, value] of Object.entries(data)) {
        if (typeof value === 'object') {
          if (value instanceof Date) {
            data[key] = formatDateForOnlineRequest(value)
          } else {
            this.formatDatesBeforeSubmit(value)
          }
        }
      }
    },
    submitForm (data) {
      // Nous devons transformer les dates en string pour ne pas prendre en compte les timezones
      this.formatDatesBeforeSubmit(data)

      this.commonApi.submitOfflineFormationForm({ 'steps': data }).then(response => {
        response.data.success ? this.dealSuccess() : this.dealFailure(response.data.errors)
      })
    },
    dealSuccess () {
      this.success = true
    },
    dealFailure (errors) {
      this.$refs.stepper.dealFailure(errors)
    }
  },
  created () {
    this.commonApi.getOfflineFormationFormInfos()
      .then(response => {
        this.steps = response['data']
        this.initialized = true
      })
  }
}
</script>

<style scoped lang="scss">
.main-centered{
    position: relative;
    padding-bottom: 2rem;
}
.pad-lg{
    padding: 2rem;
}
@media (min-width:810px) {
    .bg-company-img{
        background-image: url("~@/assets/img/loginBba.jpg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        height: 100%;
        background-attachment: fixed;
    }
    .main-centered{
        height: 70%;
    }
}

.animation-in {
   transform-origin: left;
   animation: in .6s ease-in-out;
}
.animation-out {
   transform-origin: bottom left;
   animation: out .6s ease-in-out;
}
.backButton {
  margin-top: 5%;
  width: 25%;
}
</style>
